export default "__VITE_ASSET__DuIA5mnO__"